let trackingArea = null;
const pixels = {
  enquiry:
    "https://px.ads.linkedin.com/collect/?pid=29293&conversionId=1644193&fmt=gif",
  // venueFinder: 'https://px.ads.linkedin.com/collect/?pid=29293&conversionId=1644281&fmt=gif'
  venueFinder:
    "https://px.ads.linkedin.com/collect/?pid=29293&conversionId=1821585&fmt=gif",
};
const getTrackingArea = () => {
  if (!trackingArea) {
    trackingArea = document.createElement("div");
    trackingArea.style.display = "none";
    document.body.appendChild(trackingArea);
  }
  return trackingArea;
};
const linkedinEnquiry = () => {
  const img = document.createElement("img");
  img.src = pixels.enquiry;
  getTrackingArea().appendChild(img);
};
const linkedinVenueFinder = () => {
  const img = document.createElement("img");
  img.src = pixels.venueFinder;
  getTrackingArea().appendChild(img);
};
const linkedinEvent = (event, data) => {};
export { linkedinEnquiry, linkedinVenueFinder, linkedinEvent };
